import { faStar } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import QInputProps from "./QInputProps";
import QRatingGeneric from "./QRatingGeneric";

export default function QRatingStar(p: QInputProps) {
  return <QRatingGeneric icon={faStar} color="#ffff00" {...p}/>
}